document.addEventListener("DOMContentLoaded", function () {
  // Init variables
  const authApiUrl = document.querySelector(".barkyn-auth-api-url").value;
  const editAccountButton = document.querySelector(
    ".account-customer__edit-account"
  );
  const accountModal = document.querySelector(".account_edit_modal");
  const closeModalButton = document.querySelector(".close-sidebar");
  const closeModalOverlay = document.querySelector("#sidebar-underlay");
  const modalOverlay = document.querySelector("#sidebar-underlay");
  const firstNameInput = document.querySelector("[name='first_name']");
  const lastNameInput = document.querySelector("[name='last_name']");
  const emailInput = document.querySelector("[name='email']");
  const notification = document.querySelector(`.auth-main__notification`);
  const newPasswordInput = document.querySelector("[name='password']");
  const newPasswordError = document.querySelector("[name='password_error']");
  const responseErrors = document.querySelector(".auth-main_response_error");
  const requredPasswordError = document.querySelector(
    ".password-translation-required"
  )?.value;
  const requredFirstaNameError = document.querySelector(
    ".required-first_name-error"
  )?.value;
  const requredEmailError = document.querySelector(
    ".required-email-error"
  )?.value;
  const confirmPasswordErrorMessage = document.querySelector(
    ".password-confirmation-error"
  )?.value;
  const confirmPasswordInput = document.querySelector(
    "[name='confirm_password']"
  );
  const confirmPasswordError = document.querySelector(
    "[name='confirm_password_error']"
  );
  const submutButton = document.querySelector(".auth-main__edit_account_btn");
  const submutInformationButton = document.querySelector(
    ".auth-main__edit_main_info_btn"
  );
  const successHeading = document.querySelector(
    ".account-change-password-heading"
  )?.value;
  const successMessage = document.querySelector(
    ".account-change-password-message"
  )?.value;
  const successUpdateMessage = document.querySelector(
    ".update-account-message"
  )?.value;
  const incorectPasswordError = document.querySelector(
    ".res-incorect_password"
  )?.value;
  const changePasswordButton = document.querySelector(
    ".ccount-te-modal-change-password-link"
  );
  const backButton = document.querySelector(".account_change-password-back");
  const accountMainIfoWrapper = document.querySelector(
    ".account_main-info-wrapper"
  );
  const accountMainIfoHeading = document.querySelector(
    ".account_main-info-heading"
  );
  const accountChangePasswordWrapper = document.querySelector(
    ".account_change-password-wrapper"
  );
  const accountChangePasswordHeading = document.querySelector(
    ".account_change-password-heading"
  );
  const firstNameError = document.querySelector("[name='first_name_error']");
  const emailError = document.querySelector("[name='email_error']");
  const invalidEmailError = document.querySelector(
    ".email-translation-error"
  )?.value;

  //   Methods
  //   Open Modal method
  const openModal = () => {
    accountModal.classList.add("visible");
    modalOverlay.classList.add("visible");
  };

  //   Open Modal method
  const closeModal = () => {
    accountModal.classList.remove("visible");
    modalOverlay.classList.remove("visible");
  };

  //   Show change password form method
  const showChangePasswordContent = () => {
    accountMainIfoWrapper.classList.remove("visible");
    accountMainIfoHeading.classList.remove("visible");
    accountChangePasswordHeading.classList.add("visible");
    accountChangePasswordWrapper.classList.add("visible");
    backButton.classList.add("visible");
  };

  //   Show main information form method
  const showMainInformationContent = () => {
    accountMainIfoWrapper.classList.add("visible");
    accountMainIfoHeading.classList.add("visible");
    backButton.classList.remove("visible");
    accountChangePasswordHeading.classList.remove("visible");
    accountChangePasswordWrapper.classList.remove("visible");
  };

  //  Fill account information form method
  const fillEditAccountForm = () => {
    const user = Clerk.user;
    const strategy = Clerk.user.primaryEmailAddress.verification.strategy;
    let isSocialLogin = false;
    const socialLoginStorage = localStorage.getItem("social-login");

    if (socialLoginStorage) {
      isSocialLogin = true;
    }

    if (!user) return;
    const { firstName, lastName } = user;
    const email = user?.emailAddresses[0]?.emailAddress;

    if (firstName) firstNameInput.value = firstName;
    // if (lastName) lastNameInput.value = lastName;
    if (email) emailInput.value = email;

    firstNameInput.classList.remove("error");
    firstNameError.classList.remove("visible");
    emailInput.classList.remove("error");
    emailError.classList.remove("visible");
  };

  // Validate password method
  const validatePasswordForm = (newPassword, confirmPassword) => {
    if (!newPassword) {
      newPasswordInput.classList.add("error");
      newPasswordError.innerHTML = requredPasswordError;
      newPasswordError.classList.add("visible");
    } else {
      newPasswordInput.classList.remove("error");
      newPasswordError.classList.remove("visible");
    }

    if (!confirmPassword) {
      confirmPasswordInput.classList.add("error");
      confirmPasswordError.innerHTML = requredPasswordError;
      confirmPasswordError.classList.add("visible");
    } else {
      confirmPasswordInput.classList.remove("error");
      confirmPasswordError.classList.remove("visible");
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {

      confirmPasswordError.innerHTML = confirmPasswordErrorMessage;
      confirmPasswordError.classList.add("visible");

      return false;
    } else {
      if (newPassword && confirmPassword)
        confirmPasswordError.classList.remove("visible");
    }

    return !newPassword || !confirmPassword ? false : true;
  };

  //   validate submut Form method
  const validateForm = (newPassword, confirmPassword) => {
    if (!newPassword) {
      newPasswordInput.classList.add("error");
      newPasswordError.innerHTML = requredPasswordError;
      newPasswordError.classList.add("visible");
    } else {
      newPasswordInput.classList.remove("error");
      newPasswordError.classList.remove("visible");
    }

    if (!confirmPassword) {
      confirmPasswordInput.classList.add("error");
      confirmPasswordError.innerHTML = requredPasswordError;
      confirmPasswordError.classList.add("visible");
    } else {
      confirmPasswordInput.classList.remove("error");
      confirmPasswordError.classList.remove("visible");
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      confirmPasswordError.innerHTML = confirmPasswordErrorMessage;
      confirmPasswordError.classList.add("visible");

      return false;
    } else {
      if (newPassword && confirmPassword)
        confirmPasswordError.classList.remove("visible");
    }

    return !newPassword || !confirmPassword ? false : true;
  };

  //   Validate input method
  const validateInput = (value, input, error) => {
    const requiredError = document.querySelector(`[name='${error}']`);

    if (!value) {
      input.classList.add("error");
      requiredError.innerHTML = requredPasswordError;
      requiredError.classList.add("visible");
    } else {
      input.classList.remove("error");
      requiredError.classList.remove("visible");
    }
  };

  //   Validate main ifnormation form method
  const validateMainInformationForm = (firstName, email) => {
    const validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!firstName) {
      firstNameInput.classList.add("error");
      firstNameError.innerHTML = requredFirstaNameError;
      firstNameError.classList.add("visible");
    } else {
      firstNameInput.classList.remove("error");
      firstNameError.classList.remove("visible");
    }

    if (!email) {
      emailInput.classList.add("error");
      emailError.innerHTML = requredEmailError;
      emailError.classList.add("visible");
    } else {
      if (!validRegex.test(email)) {
        emailInput.classList.add("error");
        emailError.innerHTML = invalidEmailError;
        emailError.classList.add("visible");

        return false;
      } else {
        emailInput.classList.remove("error");
        emailError.classList.remove("visible");
      }
    }

    return !firstName || !email ? false : true;
  };

  //   Show notification method
  const showNotifications = (heading = true) => {
    const headingElement = notification.querySelector(
      ".auth-main__notification-heading"
    );
    const messageElement = notification.querySelector(
      ".auth-main__notification-message"
    );
    if (headingElement && heading) headingElement.innerHTML = successHeading;
    if (messageElement)
      messageElement.innerHTML = heading
        ? successMessage
        : successUpdateMessage;

    notification.classList.add("visible");
  };

  //   Render responser errors method
  const renderResponseErrors = (error) => {
    let errorMessage = "";

    switch (error) {
      case "incorrect_password":
        errorMessage = incorectPasswordError;
        break;
    }

    responseErrors.innerHTML = errorMessage;
    responseErrors.classList.add("visible");
  };

  //   Submut Form method
  const submitForm = async () => {
    const newPassword = newPasswordInput?.value;
    const confirmPassword = confirmPasswordInput?.value;
    const userId = Clerk?.user?.id;
    const username = Clerk?.user?.firstName;
    const email = Clerk?.user?.emailAddresses[0]?.emailAddress;

    const validForm = validateForm(newPassword, confirmPassword);

    if (!validForm) return;

    submutButton.classList.add("esc-submit-button--loading");

    const clerkAuth = new ClerkAuth();
    const { ok } = await clerkAuth.editPassword(email, userId, newPassword, username);

    if (!ok) {
      console.error(res.error)
      submutButton.classList.remove("esc-submit-button--loading");
      return;
    }

    responseErrors.classList.remove("visible");
    showNotifications();
    setTimeout(() => {
      submutButton.classList.remove("esc-submit-button--loading");
      closeModal();
    }, 2000);

  };

  //   Submut main information form method
  const submitMainInformationForm = async () => {
    const userId = Clerk?.user?.id;
    const isValid = validateMainInformationForm(
      firstNameInput.value,
      emailInput.value
    );

    if (!isValid || !userId) return;

    const formData = {
      userId,
      updateEmail: false,
    };

    if (firstNameInput.value) formData.first_name = firstNameInput.value;
    // if (lastNameInput.value) formData.last_name = lastNameInput.value;
    if (emailInput.value) formData.email = emailInput.value;

    const existEmail = Clerk?.user?.emailAddresses.find(
      (i) => i.emailAddress === emailInput.value
    );
    if (!existEmail) formData.updateEmail = true;

    submutInformationButton.classList.add("esc-submit-button--loading");

    try {
      const response = await $.post(
        // `http://localhost:3002/update-user`,
        `${authApiUrl}/update-user`,
        JSON.stringify(formData)
      );

      submutInformationButton.classList.remove("esc-submit-button--loading");

      if (response?.data?.status === 500) {
        // renderResponseInformationErrors(response?.data?.data?.code);
      } else {
        responseErrors.classList.remove("visible");
        showNotifications(false);
        setTimeout(() => {
          window.location.reload();
          // closeModal();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //   Open modal event
  if (editAccountButton)
    editAccountButton.addEventListener("click", function () {
      fillEditAccountForm();
      openModal();
    });

  //   Submit chamge password form event
  if (submutButton)
    submutButton.addEventListener("click", function (e) {
      submitForm();
    });

  // Submit main information form event
  if (submutInformationButton)
    submutInformationButton.addEventListener("click", function (e) {
      submitMainInformationForm();
    });

  if (newPasswordInput)
    newPasswordInput.addEventListener("input", function (e) {
      validateInput(e.target.value, newPasswordInput, "password_error");
    });

  if (confirmPasswordInput)
    confirmPasswordInput.addEventListener("input", function (e) {
      validateInput(
        e.target.value,
        confirmPasswordInput,
        "confirm_password_error"
      );
    });

  //   Close modal event
  if (closeModalButton)
    closeModalButton.addEventListener("click", function () {
      closeModal();
    });

  //   Close modal event
  if (closeModalOverlay)
    closeModalOverlay.addEventListener("click", function () {
      closeModal();
    });

  //   Change modal state event
  if (changePasswordButton)
    changePasswordButton.addEventListener("click", function () {
      showChangePasswordContent();
    });

  if (backButton)
    backButton.addEventListener("click", function () {
      showMainInformationContent();
    });
});
